import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import api from '@/lib/api';
import type { User } from '@/types/auth';
import { useAuthStore } from '@/store/useAuthStore';

// API function to get current user
const getCurrentUser = async (): Promise<User> => {
    const response = await api.get('/auth/profile');
    return response.data;
};

// React Query hook to get current user
export const useCurrentUser = () => {
    const { setUser, setLoading } = useAuthStore();

    const query = useQuery({
        queryKey: ['user'],
        queryFn: getCurrentUser,
        enabled: !!localStorage.getItem('accessToken'),
        retry: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });

    // Handle success/error with useEffect
    useEffect(() => {
        if (query.data) {
            setUser(query.data);
        }
        if (query.error) {
            setUser(null);
            setLoading(false);
        }
    }, [query.data, query.error, setUser, setLoading]);

    return query;
};
